import { render, staticRenderFns } from "./SublessonMetadataEditor.vue?vue&type=template&id=7a1f4247&scoped=true&"
import script from "./SublessonMetadataEditor.vue?vue&type=script&lang=ts&"
export * from "./SublessonMetadataEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SublessonMetadataEditor.vue?vue&type=style&index=0&id=7a1f4247&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1f4247",
  null
  
)

export default component.exports